import { type ISliderBlockTypeOneModel } from 'shared/components/SliderBlockTypeOne/external/models/SliderBlockTypeOneModel';

import { type IChipsDataService } from '../IChipsDataService';

import { ChipsDataService } from './ChipsDataService';

/**
 * @description Сервис для работы с элементами слайдера типа один.
 * Слайдер представляет собой виджет, который содержит в себе список слайдов и чипы для выбора набора слайдов.
 * Сам слайд содержит в себе изображение снизу, заголовок и описание сверху.
 * @param items - Массив элементов слайдера типа один.
 * Каждый элемент содержит в себе название набора слайдов, список слайдов и чип для выбора набора слайдов.
 * @example
 * const sliderBlockTypeOneSlideService = new SliderBlockTypeOneSlideService(items);
 * const defaultItem = sliderBlockTypeOneSlideService.defaultItem;
 * const activeItem = sliderBlockTypeOneSlideService.getActiveItem('2021');
 */
export class SliderBlockTypeOneSlideService
  extends ChipsDataService<ISliderBlockTypeOneModel>
  implements IChipsDataService<ISliderBlockTypeOneModel> {}
